import { render, staticRenderFns } from "./updateProps.vue?vue&type=template&id=719a6acb&scoped=true"
import script from "./updateProps.vue?vue&type=script&lang=js"
export * from "./updateProps.vue?vue&type=script&lang=js"
import style0 from "./updateProps.vue?vue&type=style&index=0&id=719a6acb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "719a6acb",
  null
  
)

export default component.exports